import { render } from "./ApplicationInfoBox.vue?vue&type=template&id=590d64b4&scoped=true"
import script from "./ApplicationInfoBox.vue?vue&type=script&lang=js"
export * from "./ApplicationInfoBox.vue?vue&type=script&lang=js"

import "./ApplicationInfoBox.vue?vue&type=style&index=0&id=590d64b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590d64b4"]])

export default __exports__